export default __webpack_public_path__ + "static/media/img2.9bb73d73.PNG";